module.exports = __webpack_public_path__ + "static/media/drive2.73c7a596.png";